
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password/[step]",
      function () {
        return require("private-next-pages/forgot-password/[step].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forgot-password/[step]"])
      });
    }
  